import { motion } from "framer-motion";

// Split text into words + wrap each with a mask reveal — Awwwards-style hero animation.
export function MaskedLines({ lines, className = "", delayBase = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, li) => (
        <span key={li} className="block overflow-hidden leading-[1.02]">
          <motion.span
            className="inline-block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              ease: [0.22, 1, 0.36, 1],
              delay: delayBase + li * 0.14,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function MaskedWords({ text, className = "", wordClass = "", delayBase = 0, stagger = 0.06 }) {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-baseline">
          <motion.span
            className={`inline-block will-change-transform ${wordClass}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: delayBase + i * stagger }}
          >
            {w}{i < words.length - 1 && <span>&nbsp;</span>}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Simple scroll-in reveal — used by section wrappers
export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
